import { AbstractComponent } from '../../../definition/abstract/abstract.component';
import { DeliveryService } from './../../../service/delivery.service';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectorOptionModel } from '../../select/selector/model/selector-option.model';
import { PrePostingServiceCode } from './enum/service-code.enum';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-delivery-service-code',
  templateUrl: './delivery-service-code.component.html',
  styleUrl: './delivery-service-code.component.scss'
})
export class DeliveryServiceCodeComponent extends AbstractComponent {
    @Input() form: FormGroup;
    @Input() defaultServiceValue: string = PrePostingServiceCode.SEDEX;


    @Output() loadedOption = new EventEmitter()

    initialized = false;
    options: SelectorOptionModel[] = [];


    constructor(private deliveryService: DeliveryService) {
        super();
    }

    public override ngOnInit(): void {
        this.deliveryService.getServiceDescriptionList().subscribe(result => {
            this.options = result.map(elem => ({
                name: elem.descricao,
                value: elem.codigo,
                description: elem.codigo
            }));
            this.loadedOption.emit(true);
        })

        if (this.form && !this.form.get('serviceCode')?.getRawValue()) {
            this.form.get('serviceCode')?.setValue(PrePostingServiceCode.SEDEX)
        }
    }

    public get currentServiceValue() {
        return this.form.get('serviceCode')?.getRawValue();
    }


    protected eventServiceCodeSelection(value: string) {
        this.form.get('serviceCode')?.setValue(value);
    }
}
